import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiPermissions, apiRolesList, apiRolesView } from 'Services/UserService'

export const getData = createAsyncThunk('user/roles/getData', async datas => {
    const { data } = await apiRolesList(datas)
    return data
})

export const getView = createAsyncThunk('user/roles/getView', async id => {
    if (!id) return viewData
    const { data } = await apiRolesView(id)
    return data
})

export const getPermissions = createAsyncThunk('user/roles/getPermissions', async () => {
    const { data } = await apiPermissions()
    return data
})

const viewData = {
    store_id: '',
    name: '',
    permissions: [],
}

export const rolesSlice = createSlice({
    name: 'user/roles',
    initialState: {
        loading: true,
        view: viewData,
        permissions: [],
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            store_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setStoreId: (state, { payload }) => {
            state.table.page = 1
            state.table.store_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
            .addCase(getPermissions.pending, state => {
                state.permissions = []
            })
            .addCase(getPermissions.fulfilled, (state, { payload }) => {
                state.permissions = payload
            })
    },
})

export const { setData, setTableData, setStoreId } = rolesSlice.actions

export default rolesSlice.reducer
